import type { LoadSubImagesRegistry } from '../types/templates/load-sub-images';
import { disneyLoadSubImagesRegistry } from './DISNEY/_load-sub-images';

// Global registry that merges per-client registries.
// Templates reference these by `loadSubImagesKey`; the renderer looks them up here.
export const loadSubImagesRegistry: LoadSubImagesRegistry = {
  ...disneyLoadSubImagesRegistry
};
